import {
  AfterViewInit, Component, EventEmitter, Input, OnInit, Output
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';

import { TableLayoutMod } from 'models/layout-mod.model';
import { StylingService } from 'shared/services/styling.service';

@Component({
  selector: 'app-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss']
})
export class InputSearchComponent implements OnInit, AfterViewInit {
  @Input() mainForm!: UntypedFormGroup;

  @Input() controlName = 'search';

  @Input() placeholderTranslationKeys?: string[];

  @Input() layoutMod: TableLayoutMod = 'narrow';

  @Output() onSearch = new EventEmitter<string>();

  form!: UntypedFormGroup;

  placeholder = '';

  layoutModifier = '';

  defaultPlaceholderTranslationKeys = ['GENERAL.SEARCH'];

  constructor(
    private fb: UntypedFormBuilder,
    private translateService: TranslateService,
    private stylingService: StylingService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    if (this.mainForm) {
      this.form = this.mainForm;
    } else {
      this.form = this.fb.group({
        [this.controlName]: ['']
      });
    }

    this.translateService
      .get(this.placeholderTranslationKeys || this.defaultPlaceholderTranslationKeys)
      .subscribe((arg) => { this.placeholder = Object.values(arg).join(' / '); });

    this.layoutModifier = this.stylingService.concatLayoutModifiers('inputSearch', [this.layoutMod]);
  }

  ngAfterViewInit(): void {
    this.form.controls[this.controlName].valueChanges.pipe(
      debounceTime(150)
    ).subscribe((value: string) => {
      this.onSearch.emit(value);
    });
  }
}
